module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<div class="coming-soon">\n	<div class="text-block">\n		<h5>TRADES WILL BE AVAILABLE AFTER ROUND 1</h5>\n		<p>\n			You can make unlimited changes to your team before Round 1 by removing players from your team and adding players through the player pool.\n		</p>\n	</div>\n</div>';
}
return __p;
};
